import api, { getApiData, normalizeUsername, toArray } from '../utils/api';

function unwrapProfileResponse(response) {
  const data = getApiData(response, null);
  if (data && typeof data === 'object') return data;
  if (response?.data?.profile && typeof response.data.profile === 'object') return response.data.profile;
  if (response?.data?.employee && typeof response.data.employee === 'object') return response.data.employee;
  if (response?.data && typeof response.data === 'object' && response.data.username) return response.data;
  return null;
}

export async function getProfile(username) {
  const normalizedUsername = normalizeUsername(username);
  const params = normalizedUsername ? { params: { username: normalizedUsername } } : {};
  const response = await api.get('/profile', params);
  return unwrapProfileResponse(response);
}

export async function updateProfile(targetUsername, updates) {
  const normalizedUsername = normalizeUsername(targetUsername);
  const response = await api.put('/profile', {
    target_username: normalizedUsername || undefined,
    updates: updates && typeof updates === 'object' ? updates : {},
  });
  return unwrapProfileResponse(response);
}

export async function createEmployee(employee) {
  const response = await api.post('/employees', employee);
  return unwrapProfileResponse(response);
}

export async function getEmployees() {
  const response = await api.get('/employees');
  return toArray(getApiData(response, []));
}
